var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragHandles = function SvgDragHandles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2H3c-1.1 0-2-.9-2-2zM1 14c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2H3c-1.1 0-2-.9-2-2z"
  })));
};
export default SvgDragHandles;